import { createSlice } from "@reduxjs/toolkit";

export const initialMaterialLocalState = {
  material: {
    name: "",
    rate: "",
    volume: "",
  },
};

export const materialSlice = createSlice({
  name: "material",
  initialState: {
    materials: [],
    isAddMaterialSuccess: false,
    isAddMaterialFailedResponse: false,
    newMaterialLocal: initialMaterialLocalState,
  },

  reducers: {
    getAllMaterialAction: (state) => {},
    setAllMaterialAction: (state, { payload }) => {
      state.materials = payload;
    },

    addMaterialAction: (state, { payload }) => {},
    setAddMaterialResponse: (state, { payload }) => {
      state.isAddMaterialSuccess = payload;
    },
    updateMaterialAction: (state, { payload }) => {},
    updateMaterialResponse: (state, { payload }) => {
      state.isAddMaterialSuccess = payload;
    },

    deleteMaterialAction: (state, { payload }) => {},

    updateSingleWorkerAction: (state, { payload }) => {},

    updateMaterialError: (state, { payload }) => {
      state.isAddMaterialFailedResponse = payload;
    },

    getAllMaterialById: (state, { payload }) => {},
    setNewMaterialLocal: (state, action) => {
      state.newMaterialLocal = {
        ...state.newMaterialLocal,
        ...action.payload,
      };
    },

    resetNewMaterialLocal: (state) => {
      state.newMaterialLocal = initialMaterialLocalState;
    },
  },
});

const {
  getAllMaterialAction,
  setAllMaterialAction,
  addMaterialAction,
  setAddMaterialResponse,
  updateMaterialAction,
  updateMaterialResponse,
  updateSingleWorkerAction,
  updateMaterialError,
  deleteMaterialAction,
  getAllMaterialById,
  setNewMaterialLocal,
  resetNewMaterialLocal,
} = materialSlice.actions;

export {
  getAllMaterialAction,
  setAllMaterialAction,
  addMaterialAction,
  setAddMaterialResponse,
  updateMaterialAction,
  updateMaterialResponse,
  updateSingleWorkerAction,
  updateMaterialError,
  deleteMaterialAction,
  getAllMaterialById,
  setNewMaterialLocal,
  resetNewMaterialLocal,
};

export default materialSlice.reducer;
